var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIssueManagementLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "currentColor",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1499 24.834C4.10051 25.116 4.19168 25.4045 4.39418 25.607C4.56041 25.7732 4.78459 25.8644 5.01556 25.8644C5.06595 25.8644 5.1167 25.8601 5.1672 25.8512L11.8187 24.6863L5.3141 18.1816L4.1499 24.834Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3003 5.84044C17.9571 5.4972 17.4006 5.4972 17.0573 5.84044L6.25781 16.64L9.1875 19.5697L20.6085 8.14862L18.3003 5.84044Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1581 11.699L21.8507 9.3916L10.4297 20.8126L13.3586 23.7415L24.1581 12.942C24.5013 12.5987 24.5013 12.0423 24.1581 11.699V11.699Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6066 4.39336C22.7735 1.56029 19.0066 0 15 0C10.9934 0 7.22648 1.56029 4.39336 4.39336C1.56029 7.22648 0 10.9934 0 15C0 18.0616 0.912012 20.9827 2.60596 23.4547L3.07541 20.7721C2.21361 18.9954 1.75781 17.0329 1.75781 15C1.75781 7.69822 7.69822 1.75781 15 1.75781C22.3018 1.75781 28.2422 7.69822 28.2422 15C28.2422 22.3018 22.3018 28.2422 15 28.2422C14.5146 28.2422 14.1211 28.6357 14.1211 29.1211C14.1211 29.6065 14.5146 30 15 30C19.0066 30 22.7735 28.4397 25.6066 25.6066C28.4397 22.7735 30 19.0066 30 15C30 10.9934 28.4397 7.22648 25.6066 4.39336V4.39336Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueManagementLogo);
export default __webpack_public_path__ + "static/media/issue_management_logo.def4c0da3111e5c10cfc84c5cccef514.svg";
export { ForwardRef as ReactComponent };